$(window).on('load', function() {
    var mortgageCalculateElem = $('#mortgageCalculate');
    var itemPriceElem = $('#mortgage_calculator_price');
    var mortgagePercentElem = $("#mortgage_calculator_percent");
    var firstInstallmentElem = $("#mortgage_calculator_prepayment");
    var amountCreditElem = $("#mortgage_calculator_credit");

    var itemPrice = itemPriceElem.val() || 0;
    var firstInstallment = Math.ceil($('#ex8').data('slider-value') * itemPrice / 100) || 0;
    firstInstallmentElem.val(firstInstallment);
    amountCreditElem.val(itemPrice - firstInstallment);

    if(!$("#ex8").length){
        return false
    }

    var slider = new Slider("#ex8", {
        tooltip: 'always'
    });


    firstInstallmentElem.keyup(function (){
        var itemPrice = parseFloat(itemPriceElem.val()) || 0;
        slider.setValue( Math.ceil(firstInstallmentElem.val() * 100 / itemPrice) );
        amountCreditElem.val( itemPrice - firstInstallmentElem.val() );
    });
    slider.on("slide", function(newValue) {
        var itemPrice = parseFloat(itemPriceElem.val()) || 0;
        var firstInstallment = Math.ceil(newValue * itemPrice / 100) || 0;
        firstInstallmentElem.val(firstInstallment);
        amountCreditElem.val(itemPrice - firstInstallment);
    });
    itemPriceElem.keyup(function (){
        var itemPrice = parseFloat(itemPriceElem.val()) || 0;
        var firstInstallment = Math.ceil(slider.getValue() * itemPrice / 100) || 0;
        firstInstallmentElem.val(firstInstallment);
        amountCreditElem.val(itemPrice - firstInstallment);
    });



    $('#mortgageCalculate_btn').on('click', function (){
        mortgageCalculateElem.modal('show');
    });

    mortgageCalculateElem.on('shown.bs.modal', function (e) {
        calculate_monthly_payment();
    });


function calculate_monthly_payment() {
    var loanAmount = parseFloat(amountCreditElem.val());
    var interest_rate = parseFloat(mortgagePercentElem.val())/100;
    var monthlyInterestRate = interest_rate/12;
    var lengthOfMortgage = parseInt($('#mortgage_calculator_period').val())*12;

    var topVal = monthlyInterestRate * Math.pow((1 + monthlyInterestRate),lengthOfMortgage);
    var botVal = Math.pow((1 + monthlyInterestRate),(lengthOfMortgage))-1;
    var monthlyMortgage = parseFloat(loanAmount * (topVal / botVal)).toFixed(2);

    calculate_amortization(loanAmount, monthlyMortgage, monthlyInterestRate, lengthOfMortgage);
}

function calculate_amortization(loanAmount, monthlyMortgage, monthlyInterestRate, lengthOfMortgage) {
    monthlyMortgage = parseFloat(monthlyMortgage);
    monthlyInterestRate = parseFloat(monthlyInterestRate);
    var d = new Date();
    var n = d.getMonth();
    var y = d.getFullYear();
    var month = n+1;
    var year = y;

    var tableData = "<tr>"+
        "<th>"+TRANSLATE_MONTH+"</th>"+
        "<th>"+TRANSLATE_BALANCE+"</th>"+
        "<th>"+TRANSLATE_PAYMENT+"</th>"+
        "<th>"+TRANSLATE_PRINCIPAL+"</th>"+
        "<th>"+TRANSLATE_INTEREST+"</th>"+
        "</tr>";

    // Initializing the empty totals
    var totalMortgage = 0;
    var totalPrincipal = 0;
    var totalInterest = 0;

    var dataProvider = [];
    var principal = 0;
    var interest = 0;
    for(var i = lengthOfMortgage; i > 0; i--) {
        var monthlyInterest = parseFloat(loanAmount * monthlyInterestRate).toFixed(2);
        var monthlyPrincipal = parseFloat(monthlyMortgage - monthlyInterest).toFixed(2);
        totalMortgage = parseFloat(totalMortgage) + parseFloat(monthlyMortgage);
        totalPrincipal = parseFloat(totalPrincipal) + parseFloat(monthlyPrincipal);
        totalInterest = parseFloat(totalInterest) + parseFloat(monthlyInterest);
        var monthStr = convert_month(month);
        var tableRow = "<tr>"+
            "<td>" + monthStr + " " + year + "</td>"+
            "<td><?=$currency_icon?>" + parseFloat(loanAmount).toFixed(2) + "</td>"+
            "<td><?=$currency_icon?>" + monthlyMortgage + "</td>"+
            "<td><?=$currency_icon?>" + monthlyPrincipal + "</td>"+
            "<td><?=$currency_icon?>" + monthlyInterest + "</td>"+
            "</tr>";

        tableData = tableData + tableRow;
        principal = parseFloat(principal) + parseFloat(monthlyPrincipal);
        interest = parseFloat(interest) + parseFloat(monthlyInterest);
        if(month === 12) {
            month = 1;
            dataProvider.push({"year": year, "principal": parseFloat(principal).toFixed(2), "interest": parseFloat(interest).toFixed(2)});
            year++;
            principal = 0;
            interest = 0;
        }
        else {
            month++;
        }

        loanAmount = parseFloat(loanAmount - monthlyPrincipal).toFixed(2);

    }

    var chart = AmCharts.makeChart("chartdiv", {
        "type": "serial",
        "theme": "none",
        "legend": {
            "autoMargins": false,
            "borderAlpha": 0.2,
            "equalWidths": false,
            "horizontalGap": 10,
            "markerSize": 10,
            "useGraphSettings": true,
            "valueAlign": "left",
            "valueWidth": 0
        },
        "dataProvider": dataProvider,
        "valueAxes": [{
            "stackType": "regular",
            "axisAlpha": 0,
            "position": "left"
        }],
        "startDuration": 1,
        "graphs": [{
            "alphaField": "alpha",
            "balloonText": "<span style='font-size:13px;'>[[title]] in [[category]]:<b>[[value]]</b> [[additional]]</span>",
            "dashLengthField": "dashLengthColumn",
            "fillAlphas": 1,
            "title": TRANSLATE_PRINCIPAL,
            "type": "column",
            "lineColor": "#b2acac",
            "valueField": "principal"
        },{
            "alphaField": "alpha",
            "balloonText": "<span style='font-size:13px;'>[[title]] in [[category]]:<b>[[value]]</b> [[additional]]</span>",
            "dashLengthField": "dashLengthColumn",
            "fillAlphas": 1,
            "title": TRANSLATE_INTEREST,
            "type": "column",
            "lineColor": "#e3365c",
            "valueField": "interest"
        }
        ],
        "categoryField": "year",
        "categoryAxis": {
            "gridPosition": "start",
            "axisAlpha":0,
            "tickLength":0
        }
    });

    tableRow = "<tr>"+
            "<td></td>"+
            "<td></td>"+
            "<td><strong><?=$currency_icon?>" + parseFloat(totalMortgage).toFixed(2) + "</strong></td>"+
            "<td><strong><?=$currency_icon?>" + parseFloat(totalPrincipal).toFixed(2) + "</strong></td>"+
            "<td><strong><?=$currency_icon?>" + parseFloat(totalInterest).toFixed(2) + "</strong></td>"+
            "</tr>";
    tableData = tableData + tableRow;
    $('table#amortization').html(tableData);
}

});